<template>
    <v-layout fluid v-resize="onResize">
        <v-card class="mx-auto" elevation="4" width="100%">
            <v-toolbar v-if="deptTitle === 'CNC'" color="#FFE082">
                <v-toolbar-title class="text-center" style="font-size: 2em"
                    >{{ deptTitle }} - {{ machine_id }}
                </v-toolbar-title>
                <div class="timer ma-2 pa-2">{{ this.timer }}</div>
            </v-toolbar>
            <v-toolbar v-if="deptTitle === 'ASM'" color="pink">
                <v-toolbar-title class="text-center" style="font-size: 2em"
                    >{{ deptTitle }} - {{ machine_id }}
                </v-toolbar-title>
                <div class="timer ma-2 pa-2">{{ this.timer }}</div>
            </v-toolbar>
            <v-toolbar v-if="deptTitle === 'SIL'" color="#BBDEFB">
                <v-toolbar-title class="text-center" style="font-size: 2em"
                    >{{ deptTitle }} - {{ machine_id }}
                </v-toolbar-title>
                <div class="timer ma-2 pa-2">{{ this.timer }}</div>
            </v-toolbar>
            <v-toolbar v-if="deptTitle === 'SAW'" color="green">
                <v-toolbar-title class="text-center" style="font-size: 2em"
                    >{{ deptTitle }} - {{ machine_id }}
                </v-toolbar-title>
                <div class="timer ma-2 pa-2">{{ this.timer }}</div>
            </v-toolbar>
            <v-toolbar v-if="deptTitle === 'VACF'" color="blue">
                <v-toolbar-title class="text-center" style="font-size: 2em"
                    >{{ deptTitle }} - {{ machine_id }}
                </v-toolbar-title>
                <div class="timer ma-2 pa-2">{{ this.timer }}</div>
            </v-toolbar>

            <EasyDataTable
                :headers="table.headers"
                :items="table.items"
                :body-text-direction="bodyTextDirection"
                :header-text-direction="bodyTextDirection"
                :sort-by="sortBy"
                :sort-type="sortType"
                table-class-name="customize-table"
                theme-color="#242939"
                :table-height="windowSize.y - 85 - 85"
                :rows-per-page="10000"
                :body-row-class-name="getRowClassName"
                :loading="loading"
                :hide-footer="true"
                no-hover
                @click-row="showTabletView"
            >
                <!-- v-model:items-selected="remove" -->
                <template #loading>
                    <v-progress-circular
                        color="blue-lighten-3"
                        indeterminate
                        :size="120"
                    >
                        <v-img
                            src="/images/d3_connect.png"
                            v-if="loading"
                            :size="10"
                            class="loading-spinner"
                            :style="{
                                marginLeft: '9px',
                            }"
                            indeterminate
                        ></v-img>
                    </v-progress-circular>
                </template>

                <template #item-Active="item">
                    <div v-if="item.Active > 0">
                        <i class="mdi mdi-circle active"></i>
                    </div>
                    <div v-else>
                        <i class="mdi mdi-circle inactive"></i>
                    </div>
                </template>

                <template #item-PartNum="item">
                    <div>{{ item.PartNum }}</div>
                    <div>
                        <v-chip
                            color="white"
                            style="background-color: rgba(23, 162, 184, 255)"
                        >
                            {{ item.OpDesc }}
                        </v-chip>
                    </div>
                </template>

                <template #item-RemainQty="item">
                    <strong>{{ item.RemainQty }}</strong>
                </template>

                <template #item-Approved="item">
                    <div v-if="item.Approved === 3">
                        <i class="mdi mdi-check-circle approved"></i>
                    </div>
                    <div v-else-if="item.Approved === 2">
                        <i class="mdi mdi-circle-half-full semi-approved"></i>
                    </div>
                    <div v-else>
                        <i class="mdi mdi-close-circle unapproved"></i>
                    </div>
                </template>

                <!-- <template #item-Select="item">
                    <v-checkbox
                        v-model="remove"
                        :value="item"
                        @click="checkBug(item)"
                    ></v-checkbox>
                </template> -->
            </EasyDataTable>

            <v-row style="background-color: #e0e0e0">
                <v-col class="ma-2"
                    >Showing 1 to {{ numberOfRows }} of
                    {{ numberOfRows }} entries
                </v-col>
                <!-- <v-col class="text-end ma-2">
                    <v-btn
                        v-if="this.remove.length > 0"
                        size="x-large"
                        color="error"
                        @click="prepareForRemoval"
                        >Remove Operations</v-btn
                    >
                </v-col> -->
            </v-row>
        </v-card>
    </v-layout>

    <v-dialog
        v-model="tabletViewDialog"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
        persistent
        style="max-height: 100vh"
    >
        <Tablet
            :rowID="passRowID"
            :mainMachineProps="machine_id"
            :job_object="job_object"
            @closeTabletView="closeTabletView"
        />
    </v-dialog>
</template>

<script>
import axios from "axios";
import GuestLayout from "../../../Layouts/GuestLayout.vue";
import Tablet from "./Tablet.vue";

export default {
    components: { Tablet },
    layout: [GuestLayout],
    props: {
        errors: Object,
        auth: Object,
    },

    data() {
        return {
            table: {
                headers: [
                    { text: "Active", value: "Active" },
                    // { text: "", value: "Position", width: 0 },
                    { text: "Job #", value: "JobNum" },
                    { text: "Part #", value: "PartNum" },
                    { text: "Material", value: "Material" },
                    { text: "Run Qty", value: "RunQty" },
                    { text: "Rem Qty", value: "RemainQty" },
                    { text: "Approved", value: "Approved" },
                    // { text: "", value: "Select" },
                ],
                items: [],
            },
            bodyTextDirection: "center",
            sortBy: ["Position", "JobNum"],
            sortType: ["asc", "desc"],
            // remove: [],
            loading: false,
            tabletViewDialog: false,
            passRowID: null,
            job_object:null,
            timer: 180,
            machine_id: null,
            windowSize: {
                x: 0,
                y: 0,
            },
        };
    },
    mounted() {
        this.getJobs();
        this.startTimer();
    },
    watch: {
        timer(newVal) {
            if (newVal === 0) {
                this.getJobs();
                this.timer = 60;
            }
        },
    },
    computed: {
        numberOfRows() {
            return this.table.items.length;
        },
        deptTitle() {
            let path = window.location.pathname;
            let regex = /\/labor-(\w+)\/\w+/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },

        resourceId() {
            let path = window.location.pathname;
            let regex = /\/labor-\w+\/(\w+)/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
    },
    methods: {
        async getJobs() {
            this.loading = true;

            try {
                await axios
                    .get(
                        route("legacy-api.getSpecificTablet", {
                            tabletId: this.resourceId,
                        })
                    )
                    .then((response) => {
                        this.machine_id = response.data.data;
                    });
            } catch (err) {
                console.log(err);
            }

            //// need to wait to the top call
            switch (this.deptTitle) {
                case "CNC":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "ASM":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.resourceId,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "SIL":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "SAW":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case "VACF":
                    try {
                        await axios
                            .get(
                                route("legacy-api.getTabletJobs", {
                                    ResourceID: this.machine_id,
                                    Department: this.deptTitle,
                                })
                            )
                            .then((response) => {
                                this.table.items = response.data;
                            });
                    } catch (err) {
                        console.log(err);
                    }
                    break;
            }

            this.loading = false;
        },
        startTimer() {
            setInterval(() => {
                if (this.timer > 0) {
                    this.timer--;
                }
            }, 1000);
        },
        getRowClassName(item, index) {
            // if (item.checkbox) {
            //     return "remove-row";
            // }
            if (
                (item.OpComplete == 1 && item.RemainQty == 0) ||
                item.RemainQty > item.RunQty
            ) {
                return "complete-row";
            } else {
                return index % 2 === 0 ? "even-row" : "odd-row";
            }
        },
        showTabletView(item) {
            this.passRowID = item.SysRowID;
            this.job_object = item;
            this.tabletViewDialog = true;
        },
        closeTabletView() {
            this.tabletViewDialog = false;
        },
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },
        // prepareForRemoval(item) {
        //     let result = window.confirm(
        //         "Are you sure you want to remove these jobs from the tablet?"
        //     );
        //     if (result) {
        //         console.log("Removing:", this.remove);
        //     }
        // },
    },
};
</script>

<style scoped>
.customize-table {
    --easy-table-header-font-size: 15px;
    --easy-table-header-font-color: #242939;
    --easy-table-header-background-color: #eee;
    --easy-table-header-font-color: #242939;

    --easy-table-body-row-height: 88px;
    --easy-table-body-row-font-size: 18px;

    --easy-table-footer-background-color: #ffffff;
    --easy-table-footer-font-color: #242939;
    --easy-table-footer-font-size: 15px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 55px;

    --easy-table-rows-per-page-selector-width: 75px;
    --easy-table-rows-per-page-selector-option-padding: 15px;

    --easy-table-body-row-hover-background-color: #eee;

    --easy-table-loading-mask-background-color: #ffffff;
}

:deep(.complete-row) {
    --easy-table-body-row-background-color: lightgreen !important;
}

/* :deep(.remove-row) {
    --easy-table-body-row-background-color: pink !important;
} */
:deep(.even-row) {
    --easy-table-body-row-background-color: #f5f5f5;
}

:deep(.odd-row) {
    --easy-table-body-row-background-color: white;
}

@keyframes fadeInOut {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

.active {
    color: green;
    animation: fadeInOut 2s ease-in-out infinite;
    font-size: 1.75em;
}

.inactive {
    color: red;
    font-size: 1.75em;
}

.timer {
    color: white;
    background: black;
    border: 1px solid white;
    border-radius: 4px;
}

.approved {
    color: green;
    font-size: 1.75em;
}

.semi-approved {
    color: orange;
    font-size: 1.75em;
}

.unapproved {
    color: red;
    font-size: 1.75em;
}

.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
    transition: transform 0.2s ease-in-out;
}
</style>
